import { UPDATE_PURCHASE_ACCEPTANCE_STATUS_API } from "../../constants/api";
import { TableRowData } from "../../types/dataType";
import axios from "../fetch/fetch";

export const updateGRNDocumentStatusAPI = async (id: string, status: string): Promise<TableRowData> => {
    const body = {
        id: id,
        status: status,
    };
    const res = await axios.put(UPDATE_PURCHASE_ACCEPTANCE_STATUS_API, body);
    return res.data;
};
